import { useEffect, useState } from 'react'
import CustomerAndPolicyHistoryModel from '../model/CustomerAndPolicyHistory'
import Grid from '../../components/components/Grid/Grid'
import { toast } from 'react-toastify'
import * as constant from '../../shared/util/constant'
import {CustomerHistoryLabel as cstHistoryLabel}  from '../../shared/util/label'
import CustomerHistoryService from './CustomerAndPolicyHistoryService'
import Logger from '../../shared/services/Logger'
import { ErrorBoundary } from 'react-error-boundary'
import { FallbackComponent } from '../../shared/components/FallbackComponent'
import { Nav, Tab } from 'react-bootstrap'
import useSlider from '../../shared/components/Slider/useSlider'
import  './CustomerAndPolicyHistory.scss'

interface Props {
customerId: string
}

const CustomerAndPolicyHistory = (props: Props) => {
  // toast.configure();

  const {customerId} = props;

  const [customerHistory, setCustomerHistory] = useState<CustomerAndPolicyHistoryModel[]>([]);

  const [loading, setLoading] = useState(true);
  const [policyHistory, setPolicyHistory] = useState<CustomerAndPolicyHistoryModel[]>([]);
  const [loadingPolicy, setLoadingPolicy] = useState(true);
  const [activeHistoryTab, setActiveHistoryTab] = useState('customer');

  const customerHistoryService  = new CustomerHistoryService();
  const sliderContext = useSlider();

  const initializeCustomerHistory = async () => {
    // setCustomerHistory([])
    setLoading(true)
    if (customerId) {
      try {
         let customerHistoryData = await customerHistoryService.getHistory(customerId)
         setCustomerHistory(customerHistoryData)
      }
      catch (error) {
        toast.error(constant.ERROR_MESSAGE_LOAD, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: constant.AUTO_CLOSE
        });
        Logger.logError(error.toString());
      }
    } else {
        setCustomerHistory([])
    }

    setLoading(false);
  };

  const initializePolicyHistory = async () => {
    setLoadingPolicy(true)
    if (customerId) {
      try {
         
         let policyHistoryData = await customerHistoryService.getPolicyHistory(customerId)
         setPolicyHistory(policyHistoryData)
      }
      catch (error) {
        toast.error(constant.ERROR_MESSAGE_LOAD, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: constant.AUTO_CLOSE
        });
        Logger.logError(error.toString());
      }
    } else {
        setPolicyHistory([])
    }

    setLoadingPolicy(false);
  };


  useEffect(() => {
    setActiveHistoryTab('customer');
    initializeCustomerHistory();
    initializePolicyHistory();
  }, [customerId]);

  useEffect(() => {
    if (sliderContext.isSliderVisible) {
      document.body.classList.remove('history-no-page-scroll');
      return;
    }

    document.body.classList.add('history-no-page-scroll');
    return () => {
      document.body.classList.remove('history-no-page-scroll');
    };
  }, [sliderContext.isSliderVisible]);

  const renderHistoryGrid = (data: CustomerAndPolicyHistoryModel[], gridId: string, title: string) => {
    return (
      <div className='m-4 outerPanel card shadow-sm pb-3 border-top-0 customerHistoryGridContainer'>
        <h5 className='p-3 mb-0'>{title}</h5>
        <Grid
          grdTableContainerClass='p-0 table-container-campaign'
          data={data}
          showFilters={true}
          grdTabelClass='table-striped table-hover table-sm'
          id={gridId}
          columns={[
            {
              Header: cstHistoryLabel.USER,
              accessor: 'changedBy',
              Cell: row => <div className='gridNavigateButton text-start text-decoration-none d-block p-2 customer-history-grid-font'><span title={row.value}>{row.value}</span></div>,
              width: 140,
                  classNames:"p-2"

            },
            {
              Header: cstHistoryLabel.TIMESTAMP,
              accessor: 'changedDate',
              Cell: row => <div className='text-start text-decoration-none d-block p-2 customer-history-grid-font'><span title={row.value}>{row.value}</span></div>,
              width:220
            },
            {
              Header: cstHistoryLabel.FIELD,
              accessor: 'fieldName',
              Cell: row => <div className='text-start text-decoration-none d-block p-2 customer-history-grid-font'><span title={row.value}>{row.value}</span></div>,
              width:450
            },
            {
              Header: cstHistoryLabel.OLD_VALUE,
              accessor: 'oldValue',
              Cell: row => <div className='text-start text-decoration-none d-block p-2 customer-history-grid-font'><span title={row.value}>{row.value}</span></div>,
              width:290
            },
            {
              Header: cstHistoryLabel.NEW_VALUE,
              accessor: 'newValue',
              Cell: row => <div className='text-start text-decoration-none d-block p-2 customer-history-grid-font'><span title={row.value}>{row.value}</span></div>,
              width:290
            },
            {
              Header: cstHistoryLabel.ACTION,
              accessor: 'action',
              Cell: row => <div className='text-start text-decoration-none d-block p-2 customer-history-grid-font'><span title={row.value}>{row.value}</span></div>,
              width:90
            },
            {
              Header: cstHistoryLabel.ENTITY,
              accessor: 'entity',
              Cell: row => <div className='text-start text-decoration-none d-block p-2 customer-history-grid-font'><span title={row.value}>{row.value}</span></div>,
              width:270
            }
          ]}
          sortDefault={[]}
          hiddenColumns={['selection']} 
        />
      </div>
    );
  };

  return (
    <><br></br>
    <ErrorBoundary FallbackComponent={FallbackComponent}>
      <Tab.Container activeKey={activeHistoryTab} onSelect={(tab) => setActiveHistoryTab(tab || 'customer')}>
        <div className='history-inner-scroll'>
          <Nav variant='tabs' className='historyMiniTabs'>
            <Nav.Item>
              <Nav.Link eventKey='customer'>Customer</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey='policy'>Policy</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey='policy' className='historyTabContent'>
              {loadingPolicy ?
                (
                  <div>Loading Policy History...</div>
                ) :
                policyHistory.length > 0 ?
                  renderHistoryGrid(policyHistory, 'policyHistoryGrid', 'Policy History')
                :
                  (
                    <div>No Policy history available</div>
                  )}
            </Tab.Pane>

            <Tab.Pane eventKey='customer' className='historyTabContent'>
              {loading ?
                (
                  <div>Loading Customer History...</div>
                ) :
                customerHistory.length > 0 ?
                  renderHistoryGrid(customerHistory, 'customerHistoryGrid', 'Customer History')
                :
                  (
                    <div>No Customer history available</div>
                  )}
            </Tab.Pane>
          </Tab.Content>
        </div>
      </Tab.Container>
    </ErrorBoundary></>    
  );
}
export default CustomerAndPolicyHistory
